'use client'

import React from 'react';
import {signOut} from "next-auth/react";
import MaterialButton from "@/components/ui/buttons/global/MaterialButton";

const DashboardExpiredLogin = ({disableFullScreen}: {disableFullScreen?: boolean} = {disableFullScreen: false}) => {

    return (
        <div className={`${disableFullScreen ? '' : 'min-h-screen'} flex items-center justify-center`}>
            <div className={'space-y-2'}>
                <h3 className={'text-3xl font-bold'}>دوباره وارد شوید</h3>
                <p>نشست فعال شما منقضی شده است، لطفا دوباره وارد شوید!</p>
                <MaterialButton text={"خروج از حساب کاربری"} onClick={_ => {
                    signOut().catch(reason => {
                        console.error('logout unsuccessfully', reason)
                    });
                }}/>
            </div>
        </div>
    );
};

export default DashboardExpiredLogin;